import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Instagram, Phone, Calendar } from 'lucide-react';

const Footer = () => {
  const companyLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' }
  ];

  const servicesLinks = [
    { name: 'Website Development', path: '/services' },
    { name: 'Lead Automation', path: '/services' },
    { name: 'CRM Implementation', path: '/services' },
    { name: 'Social Media Marketing', path: '/services' },
    { name: 'SEO Services', path: '/services' }
  ];

  const socialLinks = [
    { 
      name: 'Facebook', 
      icon: Facebook, 
      url: 'https://www.facebook.com/profile.php?id=61578070613491'
    },
    { 
      name: 'LinkedIn', 
      icon: Linkedin, 
      url: 'https://www.linkedin.com/company/impactech-digital/'
    },
    { 
      name: 'Instagram', 
      icon: Instagram, 
      url: 'https://www.instagram.com/impactechdigital/'
    }
  ];

  return (
    <footer className="bg-white" style={{ borderTop: '1px solid rgba(5, 46, 108, 0.12)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="/logo-light.webp"
                alt="ImpacTech Digital"
                className="h-12 w-auto"
                data-testid="footer-logo-img"
              />
              <span className="block mt-2 text-xs font-['Inter']" style={{ color: 'rgba(5, 46, 108, 0.7)' }}>Your Growth, Automated.</span>
            </div>
            <p className="font-['Inter'] text-sm leading-relaxed mb-6" style={{ color: 'rgba(5, 46, 108, 0.55)' }}>
              Dubai-based digital marketing & automation agency helping businesses scale with data-driven strategies and intelligent automation.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full flex items-center justify-center text-[#11AAB6] transition-all duration-300 hover:scale-110"
                  style={{ backgroundColor: 'rgba(17, 170, 182, 0.12)' }}
                  aria-label={social.name}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-['Space_Grotesk'] font-bold text-[#052E6C] text-sm uppercase tracking-wide mb-4">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="font-['Inter'] text-sm hover:text-[#11AAB6] transition-colors inline-block hover:translate-x-1 duration-200"
                    style={{ color: 'rgba(5, 46, 108, 0.55)' }}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="font-['Space_Grotesk'] font-bold text-[#052E6C] text-sm uppercase tracking-wide mb-4">Services</h3>
            <ul className="space-y-3">
              {servicesLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="font-['Inter'] text-sm hover:text-[#11AAB6] transition-colors inline-block hover:translate-x-1 duration-200"
                    style={{ color: 'rgba(5, 46, 108, 0.55)' }}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Get in Touch Column */}
          <div>
            <h3 className="font-['Space_Grotesk'] font-bold text-[#052E6C] text-sm uppercase tracking-wide mb-4">Get in Touch</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+971542747863"
                  className="font-['Inter'] text-sm hover:text-[#11AAB6] transition-colors flex items-center space-x-2 group"
                  style={{ color: 'rgba(5, 46, 108, 0.55)' }}
                >
                  <Phone size={16} className="text-[#11AAB6] group-hover:scale-110 transition-transform" />
                  <span>+971 54 274 7863</span>
                </a>
              </li>
              <li>
                <a
                  href="https://booking.impactechdigital.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-['Inter'] text-sm hover:text-[#11AAB6] transition-colors flex items-center space-x-2 group"
                  style={{ color: 'rgba(5, 46, 108, 0.55)' }}
                >
                  <Calendar size={16} className="text-[#11AAB6] group-hover:scale-110 transition-transform" />
                  <span>Book a Strategy Call</span>
                </a>
              </li>
              <li className="font-['Inter'] text-sm" style={{ color: 'rgba(5, 46, 108, 0.55)' }}>
                Dubai, UAE
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" style={{ borderTop: '1px solid rgba(5, 46, 108, 0.12)' }}>
          <p className="font-['Inter'] text-sm" style={{ color: 'rgba(5, 46, 108, 0.55)' }}>
            © 2026 ImpacTech Digital. Your Growth, Automated.
          </p>
          <p className="font-['Inter'] text-xs" style={{ color: 'rgba(5, 46, 108, 0.55)' }}>
            Designed & Developed with precision in Dubai
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
